<template>
  <!-- 红包插件 -->
  <van-dialog v-model="show" title="天降红包" show-cancel-button confirmButtonText="领取"> 
    <div class="dioconten">
      <img class="img" :src="require('../../assets/img/hbll2.png')">
      <div class="tips">恭喜获得幸运红包 * <span>1</span>，是否领取？</div>
    </div>
  </van-dialog>
</template>
<script>
import { Toast } from "vant";
export default {
  name: "hbll",
  props: {},
  data() {
    return { show: true };
  },
  methods: {}
};
</script>

<style lang="less" scoped>
/deep/ .van-dialog__header {
  padding: 0;
  line-height: 55px;
  background-color: antiquewhite;
}
.dioconten {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .tips{
    padding: 10px 0;
    color: red;
  }
}
.img {
  width: 100%;
  height: 250px;
}
</style>
    